import script from "./YFHWPage17.vue?vue&type=script&setup=true&lang=js"
export * from "./YFHWPage17.vue?vue&type=script&setup=true&lang=js"

import "./YFHWPage17.vue?vue&type=style&index=0&id=487bf72b&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-487bf72b"]])

export default __exports__